var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "holiday-main-root" }, [
    _c(
      "div",
      {
        staticClass: "custom-nav-block",
        style: `padding-top:${_vm.barHeight}px`,
      },
      [
        _c("van-nav-bar", {
          staticClass: "van-bar",
          attrs: { "left-arrow": "" },
          on: { "click-left": _vm.closeWeb },
          scopedSlots: _vm._u([
            {
              key: "left",
              fn: function () {
                return [
                  _c("img", {
                    staticClass: "left-nav",
                    attrs: {
                      src: require("@/assets/packageAssets/common/arrow02.png"),
                      alt: "",
                    },
                  }),
                ]
              },
              proxy: true,
            },
            {
              key: "right",
              fn: function () {
                return [
                  _c(
                    "span",
                    {
                      staticClass: "tit-right",
                      on: { click: _vm.handleToRule },
                    },
                    [
                      _c("img", {
                        staticClass: "left-nav",
                        attrs: {
                          src: require("@/assets/packageAssets/common/rules02.png"),
                          alt: "",
                        },
                      }),
                    ]
                  ),
                ]
              },
              proxy: true,
            },
          ]),
        }),
      ],
      1
    ),
    _c(
      "div",
      {
        staticClass: "national-con",
        style: { "margin-top": `-${_vm.barHeight + 46}px` },
      },
      [
        _c("div", { staticClass: "national-head" }, [
          _c("img", {
            staticClass: "head-img-back",
            attrs: { src: require("./images/main-bg.png") },
          }),
          _c("div", { staticClass: "head-img" }, [
            _vm.$i18n.locale === "es"
              ? _c("img", { attrs: { src: _vm.getMatchTitle("tit-bg-es") } })
              : _vm.$i18n.locale === "pt"
              ? _c("img", { attrs: { src: _vm.getMatchTitle("tit-bg-pt") } })
              : _vm.$i18n.locale === "ar"
              ? _c("img", { attrs: { src: _vm.getMatchTitle("tit-bg-ar") } })
              : _vm.$i18n.locale === "tr"
              ? _c("img", { attrs: { src: _vm.getMatchTitle("tit-bg-tr") } })
              : _vm.$i18n.locale === "fr"
              ? _c("img", { attrs: { src: _vm.getMatchTitle("tit-bg-fr") } })
              : _vm.$i18n.locale === "id"
              ? _c("img", { attrs: { src: _vm.getMatchTitle("tit-bg-id") } })
              : _c("img", { attrs: { src: _vm.getMatchTitle("tit-bg-en") } }),
          ]),
        ]),
        _c("div", { staticClass: "main-con" }, [
          _c(
            "div",
            { staticClass: "act-date" },
            [
              _vm.actInfo
                ? [
                    !_vm.actInfo.started
                      ? _c("div", { staticClass: "act-enddate" }, [
                          _vm._v(
                            " " + _vm._s(_vm.$t("lang.commonM.k205")) + " "
                          ),
                          _c("i", [
                            _vm._v(
                              _vm._s(_vm.countdownResult.hours) +
                                ":" +
                                _vm._s(_vm.countdownResult.minutes) +
                                ":" +
                                _vm._s(_vm.countdownResult.seconds)
                            ),
                          ]),
                        ])
                      : _c("div", { staticClass: "act-enddate" }, [
                          _vm._v(
                            _vm._s(_vm.mexActStartTime) +
                              " - " +
                              _vm._s(_vm.mexActEndTime)
                          ),
                        ]),
                  ]
                : _vm._e(),
              _c("div", { staticStyle: { height: "12px" } }),
              _c("div", { staticClass: "act-range" }, [
                _vm._v(_vm._s(_vm.$t("lang.commonM.k333"))),
              ]),
            ],
            2
          ),
          _vm.actInfo && !!_vm.actInfo.started
            ? _c("div", { staticClass: "points-rank" }, [
                _c("div", { staticClass: "pr-item" }, [
                  _c("div", [_vm._v(_vm._s(_vm.$t("lang.commonM.k221")))]),
                  _vm.actInfo
                    ? _c("div", [_vm._v(_vm._s(_vm.actInfo.score || 0))])
                    : _vm._e(),
                ]),
                _c("div", { staticStyle: { width: "15px" } }),
                _c(
                  "div",
                  { staticClass: "pr-item" },
                  [
                    _c("div", [_vm._v(_vm._s(_vm.$t("lang.commonM.k222")))]),
                    _vm.actInfo
                      ? [
                          !_vm.actInfo.rank
                            ? _c("div", [_vm._v("--")])
                            : _c("div", [_vm._v(_vm._s(_vm.actInfo.rank))]),
                        ]
                      : _vm._e(),
                  ],
                  2
                ),
              ])
            : _vm._e(),
          _c("div", { staticClass: "part-block" }, [
            _c("div", { staticClass: "part-head" }, [
              _c("span", [_vm._v(_vm._s(_vm.$t("lang.commonM.k208")))]),
            ]),
            _vm.actInfo && !!_vm.actInfo.started
              ? _c("div", { staticClass: "part-tips" }, [
                  _vm._v(_vm._s(_vm.$t("lang.commonM.k243"))),
                ])
              : _c("div", { staticClass: "part-tips" }, [
                  _vm._v(_vm._s(_vm.$t("lang.commonM.k226"))),
                ]),
            _c("div", { staticClass: "national-gift" }, [
              _c("div", { staticClass: "gift-round" }, [
                _c("div", { staticClass: "gift-cost" }, [
                  _vm._v("+1 " + _vm._s(_vm.$t("lang.commonM.k260"))),
                ]),
                _c("img", {
                  attrs: {
                    src: require("@/assets/packageAssets/common/Pumpkin.png"),
                    alt: "",
                  },
                }),
                _c("div", { staticClass: "gift-name" }, [
                  _vm._v(_vm._s(_vm.$t("lang.commonM.k334"))),
                ]),
              ]),
              _c("div", { staticClass: "gift-round" }, [
                _c("div", { staticClass: "gift-cost" }, [
                  _vm._v("+3 " + _vm._s(_vm.$t("lang.commonM.k260"))),
                ]),
                _c("img", {
                  attrs: {
                    src: require("@/assets/packageAssets/common/Ring.png"),
                    alt: "",
                  },
                }),
                _c("div", { staticClass: "gift-name" }, [
                  _vm._v(_vm._s(_vm.$t("lang.commonM.k211"))),
                ]),
              ]),
              _c("div", { staticClass: "gift-round" }, [
                _c("div", { staticClass: "gift-cost" }, [
                  _vm._v("+5 " + _vm._s(_vm.$t("lang.commonM.k260"))),
                ]),
                _c("img", {
                  attrs: {
                    src: require("@/assets/packageAssets/common/CandyBag.png"),
                    alt: "",
                  },
                }),
                _c("div", { staticClass: "gift-name" }, [
                  _vm._v(_vm._s(_vm.$t("lang.commonM.k335"))),
                ]),
              ]),
              _c("div", { staticClass: "gift-round" }, [
                _c("div", { staticClass: "gift-cost" }, [
                  _vm._v("+15 " + _vm._s(_vm.$t("lang.commonM.k260"))),
                ]),
                _c("img", {
                  attrs: {
                    src: require("@/assets/packageAssets/common/Kiss.png"),
                    alt: "",
                  },
                }),
                _c("div", { staticClass: "gift-name" }, [
                  _vm._v(_vm._s(_vm.$t("lang.commonM.k305"))),
                ]),
              ]),
              _c("div", { staticClass: "gift-round" }, [
                _c("div", { staticClass: "gift-cost" }, [
                  _vm._v("+60 " + _vm._s(_vm.$t("lang.commonM.k260"))),
                ]),
                _c("img", {
                  attrs: {
                    src: require("@/assets/packageAssets/common/Treasure.png"),
                    alt: "",
                  },
                }),
                _c("div", { staticClass: "gift-name" }, [
                  _vm._v(_vm._s(_vm.$t("lang.commonM.k306"))),
                ]),
              ]),
            ]),
          ]),
          _c("div", { staticClass: "part-block" }, [
            _c("div", { staticClass: "part-head" }, [
              _c("span", [_vm._v(_vm._s(_vm.$t("lang.commonM.k218")))]),
            ]),
            _c("div", { staticClass: "part-tips" }, [
              _vm._v(_vm._s(_vm.$t("lang.commonM.k219"))),
            ]),
            _c("div", { staticClass: "national-reward" }, [
              _c("div", { staticClass: "national-item" }, [
                _c("div", { staticClass: "reward-num" }, [_vm._v("No.1")]),
                _c("div", { staticClass: "reward-coins" }, [
                  _vm._v(" 1000 "),
                  _c("img", {
                    staticClass: "coins-icon",
                    attrs: { src: _vm.getMatchImg("coin") },
                  }),
                ]),
              ]),
              _c("div", { staticClass: "national-item" }, [
                _c("div", { staticClass: "reward-num" }, [_vm._v("No.2")]),
                _c("div", { staticClass: "reward-coins" }, [
                  _vm._v(" 700 "),
                  _c("img", {
                    staticClass: "coins-icon",
                    attrs: { src: _vm.getMatchImg("coin") },
                  }),
                ]),
              ]),
              _c("div", { staticClass: "national-item" }, [
                _c("div", { staticClass: "reward-num" }, [_vm._v("No.3")]),
                _c("div", { staticClass: "reward-coins" }, [
                  _vm._v(" 500 "),
                  _c("img", {
                    staticClass: "coins-icon",
                    attrs: { src: _vm.getMatchImg("coin") },
                  }),
                ]),
              ]),
              _c("div", { staticClass: "national-item" }, [
                _c("div", { staticClass: "reward-num" }, [_vm._v("No.4-10")]),
                _c("div", { staticClass: "reward-coins" }, [
                  _vm._v(" 80 "),
                  _c("img", {
                    staticClass: "coins-icon",
                    attrs: { src: _vm.getMatchImg("coin") },
                  }),
                ]),
              ]),
            ]),
            _vm.actInfo && !!_vm.actInfo.started
              ? _c("div", { staticClass: "btn-block" }, [
                  _c(
                    "div",
                    {
                      staticClass: "national-btn",
                      on: { click: _vm.handleToRank },
                    },
                    [_vm._v(_vm._s(_vm.$t("lang.commonM.k220")))]
                  ),
                ])
              : _vm._e(),
          ]),
          _vm.actInfo && !_vm.actInfo.started
            ? _c("div", { staticClass: "part-block" }, [
                _c("div", { staticClass: "part-head" }, [
                  _c("span", [_vm._v(_vm._s(_vm.$t("lang.commonM.k225")))]),
                ]),
                _c("div", { staticClass: "part-tips" }, [
                  _vm._v(" " + _vm._s(_vm.$t("lang.commonM.k246")) + " "),
                  _vm.actInfo && !_vm.actInfo.started
                    ? _c("i", [_vm._v(_vm._s(_vm.$t("lang.commonM.k223")))])
                    : _vm._e(),
                ]),
                _c(
                  "div",
                  {
                    staticClass: "national-props",
                    staticStyle: { "margin-top": "0" },
                  },
                  [
                    _vm.packageName !== "echo"
                      ? [
                          _c("div", { staticClass: "national-props-item" }, [
                            _vm._m(0),
                            _c("div", [
                              _vm._v(_vm._s(_vm.$t("lang.commonM.k336"))),
                            ]),
                          ]),
                          _c("div", { staticStyle: { width: "20px" } }),
                        ]
                      : _vm._e(),
                    _c("div", { staticClass: "national-props-item" }, [
                      _c("div", [
                        _c("img", {
                          attrs: { src: _vm.getMatchImg("super-chat-pass") },
                        }),
                      ]),
                      _c("div", [_vm._v(_vm._s(_vm.$t("lang.commonM.k088")))]),
                    ]),
                  ],
                  2
                ),
                _c("div", { staticClass: "national-props" }, [
                  _c("div", { staticClass: "national-props-item" }, [
                    _c("div", [
                      _c("img", {
                        attrs: { src: _vm.getMatchImg("video-pass") },
                      }),
                    ]),
                    _c("div", [_vm._v(_vm._s(_vm.$t("lang.commonM.k087")))]),
                  ]),
                  _c("div", { staticStyle: { width: "20px" } }),
                  _c("div", { staticClass: "national-props-item" }, [
                    _c("div", [
                      _c("img", { attrs: { src: _vm.getMatchImg("coupon") } }),
                    ]),
                    _c("div", [_vm._v(_vm._s(_vm.$t("lang.giftSign.coupon")))]),
                  ]),
                ]),
              ])
            : _vm._e(),
          _vm.actInfo && !!_vm.actInfo.started
            ? _c("div", { staticClass: "part-block" }, [
                _c("div", { staticClass: "part-head" }, [
                  _c("span", [_vm._v(_vm._s(_vm.$t("lang.commonM.k225")))]),
                ]),
                _c(
                  "div",
                  { staticClass: "part-tips" },
                  [
                    _vm.actInfo && !_vm.actInfo.started
                      ? [_vm._v(_vm._s(_vm.$t("lang.commonM.k223")))]
                      : [_vm._v(_vm._s(_vm.$t("lang.commonM.k307")))],
                  ],
                  2
                ),
                _vm.actInfo.signTask
                  ? _c("div", { staticClass: "task-item" }, [
                      _c("span", { staticClass: "task-item-tit" }, [
                        _vm._v(" " + _vm._s(_vm.$t("lang.commonM.k265")) + " "),
                        _c("span", [_vm._v(_vm._s(_vm.actInfo.signTask.proc))]),
                        _vm._v("/"),
                        _c("i", [_vm._v(_vm._s(_vm.actInfo.signTask.target))]),
                      ]),
                      _c("div", { staticClass: "task-item-reward" }, [
                        _c("div", { staticClass: "task-item-gift" }, [
                          _c("div", { staticClass: "item-gift-img" }, [
                            _c("img", {
                              attrs: {
                                src: _vm.getMatchImg("super-chat-pass"),
                              },
                            }),
                          ]),
                          _c("div", { staticClass: "item-gift-num" }, [
                            _vm._v("x1"),
                          ]),
                        ]),
                      ]),
                      _vm.actInfo.signTask.state == 0
                        ? _c(
                            "div",
                            {
                              staticClass: "task-item-btn",
                              on: { click: _vm.handleSign },
                            },
                            [_vm._v(_vm._s(_vm.$t("lang.commonM.k293")))]
                          )
                        : _vm._e(),
                      _vm.actInfo.signTask.state == 1
                        ? _c(
                            "div",
                            { staticClass: "task-item-btn disable" },
                            [
                              _vm.leftClassObj &&
                              _vm.leftClassObj.countdownResult
                                ? [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.leftClassObj.countdownResult.hours
                                        ) +
                                        ":" +
                                        _vm._s(
                                          _vm.leftClassObj.countdownResult
                                            .minutes
                                        ) +
                                        ":" +
                                        _vm._s(
                                          _vm.leftClassObj.countdownResult
                                            .seconds
                                        ) +
                                        " "
                                    ),
                                  ]
                                : _vm._e(),
                            ],
                            2
                          )
                        : _vm._e(),
                    ])
                  : _vm._e(),
                _vm.actInfo.send1Task
                  ? _c("div", { staticClass: "task-item" }, [
                      _c("span", { staticClass: "task-item-tit" }, [
                        _vm._v(" " + _vm._s(_vm.$t("lang.commonM.k245")) + " "),
                        _c("span", [
                          _vm._v(_vm._s(_vm.actInfo.send1Task.proc)),
                        ]),
                        _vm._v("/"),
                        _c("i", [_vm._v(_vm._s(_vm.actInfo.send1Task.target))]),
                      ]),
                      _c(
                        "div",
                        { staticClass: "task-item-reward" },
                        [
                          _vm.packageName !== "echo"
                            ? [
                                _vm._m(1),
                                _c("div", { staticClass: "task-item-gap" }),
                              ]
                            : _vm._e(),
                          _c("div", { staticClass: "task-item-gift" }, [
                            _c("div", { staticClass: "item-gift-img" }, [
                              _c("img", {
                                attrs: { src: _vm.getMatchImg("video-pass") },
                              }),
                            ]),
                            _c("div", { staticClass: "item-gift-num" }, [
                              _vm._v("x2"),
                            ]),
                          ]),
                        ],
                        2
                      ),
                      _vm.actInfo.send1Task.state == 0
                        ? _c(
                            "div",
                            {
                              staticClass: "task-item-btn",
                              on: { click: _vm.handleToChatList },
                            },
                            [_vm._v(_vm._s(_vm.$t("lang.commonM.k273")))]
                          )
                        : _vm._e(),
                      _vm.actInfo.send1Task.state == 1
                        ? _c(
                            "div",
                            {
                              staticClass: "task-item-btn",
                              on: {
                                click: function ($event) {
                                  return _vm.handleClaim(1)
                                },
                              },
                            },
                            [_vm._v(_vm._s(_vm.$t("lang.commonM.k073")))]
                          )
                        : _vm._e(),
                      _vm.actInfo.send1Task.state == 2
                        ? _c(
                            "div",
                            { staticClass: "task-item-btn disable" },
                            [
                              _vm.leftClassObj &&
                              _vm.leftClassObj.countdownResult
                                ? [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.leftClassObj.countdownResult.hours
                                        ) +
                                        ":" +
                                        _vm._s(
                                          _vm.leftClassObj.countdownResult
                                            .minutes
                                        ) +
                                        ":" +
                                        _vm._s(
                                          _vm.leftClassObj.countdownResult
                                            .seconds
                                        ) +
                                        " "
                                    ),
                                  ]
                                : _vm._e(),
                            ],
                            2
                          )
                        : _vm._e(),
                    ])
                  : _vm._e(),
                _vm.actInfo.send5Task
                  ? _c("div", { staticClass: "task-item" }, [
                      _c("span", { staticClass: "task-item-tit" }, [
                        _vm._v(" " + _vm._s(_vm.$t("lang.commonM.k308")) + " "),
                        _c("span", [
                          _vm._v(_vm._s(_vm.actInfo.send5Task.proc)),
                        ]),
                        _vm._v("/"),
                        _c("i", [_vm._v(_vm._s(_vm.actInfo.send5Task.target))]),
                      ]),
                      _c(
                        "div",
                        { staticClass: "task-item-reward" },
                        [
                          _c("div", { staticClass: "task-item-gift" }, [
                            _c("div", { staticClass: "item-gift-img" }, [
                              _c("img", {
                                attrs: {
                                  src: _vm.getMatchImg("super-chat-pass"),
                                },
                              }),
                            ]),
                            _c("div", { staticClass: "item-gift-num" }, [
                              _vm._v("x2"),
                            ]),
                          ]),
                          _c("div", { staticClass: "task-item-gap" }),
                          _vm.packageName !== "echo"
                            ? [
                                _vm._m(2),
                                _c("div", { staticClass: "task-item-gap" }),
                              ]
                            : _vm._e(),
                          _c("div", { staticClass: "task-item-gift" }, [
                            _c("div", { staticClass: "item-gift-img" }, [
                              _c("img", {
                                attrs: { src: _vm.getMatchImg("video-pass") },
                              }),
                            ]),
                            _c("div", { staticClass: "item-gift-num" }, [
                              _vm._v("x5"),
                            ]),
                          ]),
                          _c("div", { staticClass: "task-item-gap" }),
                          _c("div", { staticClass: "task-item-gift" }, [
                            _c("div", { staticClass: "item-gift-img" }, [
                              _c("img", {
                                attrs: { src: _vm.getMatchImg("coupon") },
                              }),
                            ]),
                            _c("div", { staticClass: "item-gift-num" }, [
                              _vm._v("x1"),
                            ]),
                          ]),
                        ],
                        2
                      ),
                      _vm.actInfo.send5Task.state == 0
                        ? _c(
                            "div",
                            {
                              staticClass: "task-item-btn",
                              on: { click: _vm.handleToChatList },
                            },
                            [_vm._v(_vm._s(_vm.$t("lang.commonM.k273")))]
                          )
                        : _vm._e(),
                      _vm.actInfo.send5Task.state == 1
                        ? _c(
                            "div",
                            {
                              staticClass: "task-item-btn",
                              on: {
                                click: function ($event) {
                                  return _vm.handleClaim(5)
                                },
                              },
                            },
                            [_vm._v(_vm._s(_vm.$t("lang.commonM.k073")))]
                          )
                        : _vm._e(),
                      _vm.actInfo.send5Task.state == 2
                        ? _c(
                            "div",
                            { staticClass: "task-item-btn disable" },
                            [
                              _vm.leftClassObj &&
                              _vm.leftClassObj.countdownResult
                                ? [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.leftClassObj.countdownResult.hours
                                        ) +
                                        ":" +
                                        _vm._s(
                                          _vm.leftClassObj.countdownResult
                                            .minutes
                                        ) +
                                        ":" +
                                        _vm._s(
                                          _vm.leftClassObj.countdownResult
                                            .seconds
                                        ) +
                                        " "
                                    ),
                                  ]
                                : _vm._e(),
                            ],
                            2
                          )
                        : _vm._e(),
                    ])
                  : _vm._e(),
              ])
            : _vm._e(),
          _vm.actInfo && !_vm.actInfo.started
            ? _c("div", { staticClass: "btn-block" }, [
                _c(
                  "div",
                  {
                    staticClass: "national-btn",
                    on: { click: _vm.handleGotIt },
                  },
                  [_vm._v(_vm._s(_vm.$t("lang.gotit")))]
                ),
              ])
            : _vm._e(),
        ]),
      ]
    ),
    _vm.showSuccess
      ? _c("div", { staticClass: "act-mask" }, [
          _c("div", { staticClass: "dia-bg" }, [
            _c(
              "div",
              { staticClass: "con-block" },
              [
                _c("div", { staticClass: "gifts-tit" }, [
                  _c("span", [
                    _vm._v(_vm._s(_vm.$t("lang.commonM.k147")) + "!"),
                  ]),
                ]),
                _vm.showSuccess === 1
                  ? _c("div", { staticClass: "gifts" }, [
                      _c("div", [
                        _c("div", { staticClass: "img-wrap" }, [
                          _c("img", {
                            attrs: {
                              src: _vm.getMatchImg("super-chat-pass"),
                              alt: "",
                            },
                          }),
                        ]),
                        _c("div", { staticClass: "rewards-name" }, [
                          _vm._v(_vm._s(_vm.$t("lang.commonM.k088"))),
                        ]),
                        _c("div", { staticClass: "rewards-count" }, [
                          _vm._v("x1"),
                        ]),
                      ]),
                    ])
                  : _vm._e(),
                _vm.showSuccess === 2
                  ? _c(
                      "div",
                      { staticClass: "gifts" },
                      [
                        _vm.packageName !== "echo"
                          ? [
                              _c("div", [
                                _vm._m(3),
                                _c("div", { staticClass: "rewards-name" }, [
                                  _vm._v(_vm._s(_vm.$t("lang.commonM.k336"))),
                                ]),
                                _c("div", { staticClass: "rewards-count" }, [
                                  _vm._v("x1"),
                                ]),
                              ]),
                              _c("div", { staticClass: "gift-gap" }),
                            ]
                          : _vm._e(),
                        _c("div", [
                          _c("div", { staticClass: "img-wrap" }, [
                            _c("img", {
                              attrs: {
                                src: _vm.getMatchImg("video-pass"),
                                alt: "",
                              },
                            }),
                          ]),
                          _c("div", { staticClass: "rewards-name" }, [
                            _vm._v(_vm._s(_vm.$t("lang.commonM.k087"))),
                          ]),
                          _c("div", { staticClass: "rewards-count" }, [
                            _vm._v("x2"),
                          ]),
                        ]),
                      ],
                      2
                    )
                  : _vm._e(),
                _vm.showSuccess === 3
                  ? [
                      _c(
                        "div",
                        {
                          staticClass: "gifts",
                          staticStyle: {
                            "justify-content": "space-around",
                            "margin-bottom": "0",
                          },
                        },
                        [
                          _vm.packageName !== "echo"
                            ? [
                                _c("div", [
                                  _vm._m(4),
                                  _c("div", { staticClass: "rewards-name" }, [
                                    _vm._v(_vm._s(_vm.$t("lang.commonM.k336"))),
                                  ]),
                                  _c("div", { staticClass: "rewards-count" }, [
                                    _vm._v("x2"),
                                  ]),
                                ]),
                              ]
                            : _vm._e(),
                          _c("div", [
                            _c("div", { staticClass: "img-wrap" }, [
                              _c("img", {
                                attrs: {
                                  src: _vm.getMatchImg("super-chat-pass"),
                                  alt: "",
                                },
                              }),
                            ]),
                            _c("div", { staticClass: "rewards-name" }, [
                              _vm._v(_vm._s(_vm.$t("lang.commonM.k088"))),
                            ]),
                            _c("div", { staticClass: "rewards-count" }, [
                              _vm._v("x2"),
                            ]),
                          ]),
                        ],
                        2
                      ),
                      _c(
                        "div",
                        {
                          staticClass: "gifts",
                          staticStyle: { "justify-content": "space-around" },
                        },
                        [
                          _c("div", [
                            _c("div", { staticClass: "img-wrap" }, [
                              _c("img", {
                                attrs: {
                                  src: _vm.getMatchImg("video-pass"),
                                  alt: "",
                                },
                              }),
                            ]),
                            _c("div", { staticClass: "rewards-name" }, [
                              _vm._v(_vm._s(_vm.$t("lang.commonM.k087"))),
                            ]),
                            _c("div", { staticClass: "rewards-count" }, [
                              _vm._v("x5"),
                            ]),
                          ]),
                          _c("div", [
                            _c("div", { staticClass: "img-wrap" }, [
                              _c("img", {
                                attrs: {
                                  src: _vm.getMatchImg("coupon"),
                                  alt: "",
                                },
                              }),
                            ]),
                            _c("div", { staticClass: "rewards-name" }, [
                              _vm._v(_vm._s(_vm.$t("lang.giftSign.coupon"))),
                            ]),
                            _c("div", { staticClass: "rewards-count" }, [
                              _vm._v("x1"),
                            ]),
                          ]),
                        ]
                      ),
                    ]
                  : _vm._e(),
                _c(
                  "div",
                  {
                    staticClass: "gifts-confirm",
                    on: {
                      click: function ($event) {
                        _vm.showSuccess = 0
                      },
                    },
                  },
                  [_c("div", [_vm._v(_vm._s(_vm.$t("lang.ok")))])]
                ),
              ],
              2
            ),
          ]),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", [
      _c("img", { attrs: { src: require("./images/avatar-bar.png") } }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "task-item-gift" }, [
      _c("div", { staticClass: "item-gift-img" }, [
        _c("img", { attrs: { src: require("./images/avatar-bar.png") } }),
      ]),
      _c("div", { staticClass: "item-gift-num" }, [_vm._v("x1")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "task-item-gift" }, [
      _c("div", { staticClass: "item-gift-img" }, [
        _c("img", { attrs: { src: require("./images/avatar-bar.png") } }),
      ]),
      _c("div", { staticClass: "item-gift-num" }, [_vm._v("x2")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "img-wrap" }, [
      _c("img", {
        attrs: { src: require("./images/avatar-bar.png"), alt: "" },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "img-wrap" }, [
      _c("img", {
        attrs: { src: require("./images/avatar-bar.png"), alt: "" },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }